module.exports = __webpack_public_path__ + "static/media/diamonds-jack.c9ba203f.png";